import React, {
  useState,
} from "react";
import "./setting.scss";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarContent,
  SidebarFooter,
} from "react-pro-sidebar";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { useStyles } from "./styles";
import Divider from "@material-ui/core/Divider";
import Switch from "react-switch";
import Box from "@material-ui/core/Box";
import ClearIcon from "@material-ui/icons/Clear";
import sidebarBg1 from "./bg1.jpg";
import sidebarBg2 from "./bg2.jpg";
import "./darkmode.css";

const listBackround = [
  {
    id: 1,
    name: sidebarBg1,
    description: "twinkle",
  },
  {
    id: 2,
    name: sidebarBg2,
    description: "wolf",
  },
];

const SettingBar = ({
  image,
  collapsed,
  rtl,
  toggled,
  handleToggleSidebar,
  handleCollapsedChange,
  handleImageChange,
  props,
  activeMenu,
  handleOnClick,
  HandleCloseSetting,
  imageBackground,
  HandleChangeImageBackground,
}) => {
  const classes = useStyles();
  const [toggle, setToggle] = useState(false);

  const setDark = () => {
    localStorage.setItem("theme", "dark");
    document.documentElement.setAttribute("data-theme", "dark");
  };

  const setLight = () => {
    localStorage.setItem("theme", "light");
    document.documentElement.setAttribute("data-theme", "light");
  };

  const toggleTheme = (e) => {
    setToggle(!toggle);
    if (!toggle) {
      setDark();
    } else {
      setLight();
    }
  };

  return (
    <ProSidebar
      // image={sidebarBg}
      image={false}
      rtl={rtl}
      toggled={toggled}
      breakPoint="md"
      onToggle={handleToggleSidebar}
      className={`setting ${activeMenu ? classes.Setting : classes.UnSetting}`}
    >
      <SidebarHeader>
        <div
          style={{
            padding: "20px",
            textTransform: "uppercase",
            fontWeight: "bold",
            fontSize: 15,
            letterSpacing: "1px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            color: "#fff",
            boxSizing: "border-box",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {" "}
          Setting <ClearIcon onClick={() => HandleCloseSetting()} />
        </div>
        <ListItemIcon></ListItemIcon>
      </SidebarHeader>

      <SidebarContent>
        <Menu title="Background">
          <div
            style={{
              padding: "20px 20px 4px",
              textTransform: "uppercase",
              fontWeight: "bold",
              fontSize: 12,
              letterSpacing: "1px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              color: "#000",
              boxSizing: "border-box",
            }}
          >
            {" "}
            Background{" "}
          </div>
          <Divider style={{ width: "94%", margin: "auto" }} />
          <MenuItem
            icon={
              <Switch
                height={16}
                width={30}
                checkedIcon={false}
                uncheckedIcon={false}
                onChange={handleImageChange}
                checked={image === true ? true : false}
                onColor="#219de9"
                offColor="#bbbbbb"
              />
            }
          >
            <ListItem>
              <ListItemText>On/Off</ListItemText>
            </ListItem>
          </MenuItem>
          <ListItem>
            {listBackround.map((item) => {
              return (
                <Box key={item.id} className={classes.ImageBox}>
                  <img
                    src={item.name}
                    alt={item.description}
                    title={item.description}
                    height="50px"
                    width="50px"
                    style={
                      // eslint-disable-next-line
                      String(item.id) == imageBackground
                        ? {
                            border: "1px solid var(--itsm-item-template-dark)",
                            padding: "2px",
                            objectFit: "cover",
                            margin: "4px",
                            height: "40px",
                            width: "40px",
                          }
                        : {
                            objectFit: "cover",
                            margin: "4px",
                            height: "40px",
                            width: "40px",
                          }
                    }
                    className={classes.ImageItemSetting}
                    onClick={() => HandleChangeImageBackground(item.id)}
                  />
                </Box>
              );
            })}
          </ListItem>
        </Menu>
        <Menu title="Color Scheme">
          <div
            style={{
              padding: "20px 20px 4px",
              textTransform: "uppercase",
              fontWeight: "bold",
              fontSize: 12,
              letterSpacing: "1px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              color: "#000",
              boxSizing: "border-box",
            }}
          >
            {" "}
            Color Scheme{" "}
          </div>
          <Divider style={{ width: "94%", margin: "auto" }} />
          <MenuItem
            icon={
              <Switch
                height={16}
                width={30}
                checkedIcon={false}
                uncheckedIcon={false}
                onChange={toggleTheme}
                checked={toggle}
                onColor="#219de9"
                offColor="#bbbbbb"
              />
            }
          >
            <ListItem>
              <ListItemText>Chế độ tối</ListItemText>
            </ListItem>
          </MenuItem>
          <MenuItem
            icon={
              <Switch
                height={16}
                width={30}
                checkedIcon={false}
                uncheckedIcon={false}
                onChange={handleCollapsedChange}
                checked={collapsed}
                onColor="#bbbbbb"
                offColor="#219de9"
              />
            }
          >
            <ListItem>
              <ListItemText>Dark Mode</ListItemText>
            </ListItem>
          </MenuItem>
        </Menu>
      </SidebarContent>

      <SidebarFooter style={{ textAlign: "left" }}>
        <Menu>
          <MenuItem
            icon={
              <Switch
                height={16}
                width={30}
                checkedIcon={false}
                uncheckedIcon={false}
                onChange={handleCollapsedChange}
                checked={!collapsed}
                onColor="#219de9"
                offColor="#bbbbbb"
              />
            }
          >
            <ListItem>
              <ListItemText>Bật/Tắt Menu</ListItemText>
            </ListItem>
          </MenuItem>
        </Menu>
      </SidebarFooter>
    </ProSidebar>
  );
};

export default SettingBar;
